"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HardforksOrdered = exports.BlockTags = void 0;
var BlockTags;
(function (BlockTags) {
    BlockTags["EARLIEST"] = "earliest";
    BlockTags["LATEST"] = "latest";
    BlockTags["PENDING"] = "pending";
    BlockTags["SAFE"] = "safe";
    BlockTags["FINALIZED"] = "finalized";
})(BlockTags || (exports.BlockTags = BlockTags = {}));
// This list of hardforks is expected to be in order
// keep this in mind when making changes to it
var HardforksOrdered;
(function (HardforksOrdered) {
    HardforksOrdered["zond"] = "zond";
})(HardforksOrdered || (exports.HardforksOrdered = HardforksOrdered = {}));
//# sourceMappingURL=qrl_types.js.map